import { defineStore } from 'pinia'
import type { Context } from '@/types/conductor.d'
import conductorService from '@/api/conductorService'
import {Sport} from "@/composables/useSports";

interface ContextInfo {
  brand: string
  sports: Sport[]
}

export const useContextStore = defineStore('contextStore', {
  state: () => ({
    contextMap: {} as Record<string, ContextInfo>
  }),

  actions: {
    setContextMap(contexts: Context[]) {
      const map: Record<string, ContextInfo> = {}
      contexts.forEach(ctx => {
        if (!ctx.name || !ctx.brand) return
        const sports: Sport[] = []
        ctx.configurationParameters?.forEach(param => {
          if (param.value !== 'true') return
          switch (param.name) {
            case 'feature.sport.horseRacing': sports.push('HORSE_RACING'); break
            case 'feature.sport.soccer': sports.push('SOCCER'); break
            case 'feature.sport.americanFootball': sports.push('AMERICAN_FOOTBALL'); break
          }
        })
        map[ctx.name] = { brand: ctx.brand, sports }
      })
      this.contextMap = map
    },
  },
})